import { useFormContext } from 'react-hook-form';

import { Distributor } from '@larvitu/shared/react/components/feature-distributor';

import type { DistributorProps } from '@larvitu/shared/react/components/feature-distributor';
import type { HeaderContextProps } from '@larvitu/shared/react/context/feature-header-context';
import type { FC } from 'react';
import type { UseFormReturn } from 'react-hook-form';


export interface FormProviderProps<
  T extends Array<keyof UseFormReturn> = Array<keyof UseFormReturn>,
> {
  children: DistributorProps<
    {
      [Key in T[number]]: UseFormReturn[Key];
    }
  >['children'];
  props?: T;
}

export const FormConsumer: FC<FormProviderProps> = ({ children, props }) => {
  let formContext = useFormContext();

  if (props) {
    formContext = props.reduce<Partial<HeaderContextProps>>(
      (acc, key) => ({
        ...acc,
        [key]: formContext[key],
      }),
      {},
    );
  }

  return (
    <Distributor {...{ ...formContext, ...props }}>
      {children}
    </Distributor>
  );
};
